/* eslint-disable */

export function initCountdownCanvas() {
	/**
	 * Parse date in d/m/Y format (e.g., "26/12/2025")
	 * @param {string} dateStr - Date string in d/m/Y format
	 * @returns {Date} Parsed date object
	 */
	function parseDateDMY(dateStr) {
		if (!dateStr) return null;

		const parts = dateStr.split('/');
		if (parts.length !== 3) return null;

		const day = parseInt(parts[0], 10);
		const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-based
		const year = parseInt(parts[2], 10);

		return new Date(year, month, day);
	}

	function daysBetween(date1, date2) {
		// 1 ngày = 1000ms * 60s * 60p * 24h
		const oneDay = 1000 * 60 * 60 * 24;

		return Math.round((date2 - date1) / oneDay);
	}

	let start_date;
	let end_date;

	document.querySelectorAll("[data-start]").forEach((el) => {
		start_date = el.dataset.start;
		end_date = el.dataset.end;

		const day = el.querySelector(".remaining");

		const start = parseDateDMY(start_date);
		const end = parseDateDMY(end_date);
		const today = new Date();

		// Set today to start of day for accurate comparison
		today.setHours(0, 0, 0, 0);

		if (!start || !end) {
			console.error('Invalid date format. Expected d/m/Y (e.g., 26/12/2025)');
			return;
		}

		const total = daysBetween(start, end);

		const remaining = daysBetween(today, end);

		if (remaining >= 0) {
			day.innerHTML = remaining;
		}

		// tính % đã qua
		const percent = Math.min(Math.max(remaining / total, 0), 1);

		const canvas = el.querySelector("canvas");

		if (!canvas) return;

		const ctx = canvas.getContext("2d");

		// get width, r, tâm
		const size = canvas.width;
		const center = size / 2;
		const radius = center - 6;

		// clear

		ctx.clearRect(0, 0, size, size);

		// vòng nền
		ctx.beginPath();
		ctx.arc(center, center, radius, 0, Math.PI * 2);
		ctx.strokeStyle = "#FBF1DF";
		ctx.lineWidth = 2;
		ctx.stroke();

		// vòng progress
		ctx.beginPath();
		ctx.arc(
			center,
			center,
			radius,
			-Math.PI / 2,
			-Math.PI / 2 + percent * Math.PI * 2,
		);
		ctx.strokeStyle = "#ECB95D";
		ctx.lineWidth = 6;
		ctx.lineCap = "round";
		ctx.stroke();
	});
}
